<script>
import { mapStores } from "pinia";
import { defineComponent } from "vue";

import LanguageSelectorModal from "@/components/modals/LanguageSelectorModal.vue";
import OnboardingModal from "@/components/modals/OnboardingModal.vue";
import SupportModal from "@/components/modals/SupportModal.vue";
import { useAuthStore, useModalStore, useSettingsStore } from "@/stores";

export default defineComponent({
  components: {
    LanguageSelectorModal,
    OnboardingModal,
    SupportModal
  },
  computed: {
    ...mapStores(useAuthStore, useSettingsStore, useModalStore),

    stateToWatch() {
      return {
        routeName: this.$route.name,
        routeMeta: this.$route.meta,

        onboardingOpen: this.modalStore.onboarding.isOpen,
        onboardingShown: this.settingsStore.userPreferences.onboardingShown,

        languageSelectorOpen: this.modalStore.languageSelector.isOpen,
        activeLanguageGroup: this.settingsStore.activeLanguageGroup,

        supportOpen: this.modalStore.support.isOpen
      };
    }
  },
  watch: {
    stateToWatch: {
      handler: function (newValue, oldValue) {
        if (!this.authStore.isAuthenticated) {
          return;
        }

        const {
          routeName,
          routeMeta,

          onboardingOpen,
          onboardingShown,

          languageSelectorOpen,
          activeLanguageGroup
        } = newValue;

        const routeWasChanged = routeName !== oldValue?.routeName;

        // Language modal should not be kept open when using the browser history, if
        // a language group has already been selected
        if (routeWasChanged && languageSelectorOpen && activeLanguageGroup) {
          this.modalStore.setModalState("languageSelector", false);
        }

        // One of the modals is already open, do nothing
        if (onboardingOpen || languageSelectorOpen) {
          return;
        }

        // Handle "Onboarding" modal
        if (!onboardingShown && routeName !== null && routeMeta?.disableOnboarding !== true) {
          this.modalStore.setModalState("onboarding", true);
          return;
        }

        // Handle "Language Selection" modal
        if (!activeLanguageGroup && routeMeta?.forceLanguageSelection === true) {
          this.modalStore.setModalState("languageSelector", true);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeOnboardingModal() {
      this.modalStore.setModalState("onboarding", false);
    },
    closeLanguageSelectorModal() {
      this.modalStore.setModalState("languageSelector", false);
    },
    closeSupportModal() {
      this.modalStore.setModalState("support", false);
    }
  }
});
</script>

<template>
  <div>
    <OnboardingModal :is-open="modalStore.onboarding.isOpen" @close="closeOnboardingModal()" />
    <LanguageSelectorModal
      :is-open="modalStore.languageSelector.isOpen"
      @close="closeLanguageSelectorModal()"
    />
    <SupportModal :is-open="modalStore.support.isOpen" @close="closeSupportModal()" />
  </div>
</template>
